export var BASE_USER_CALENDAR_KEY = 'user-calendar';
var userCalendarKeys = {
  userCalendar: [BASE_USER_CALENDAR_KEY]
};
export default userCalendarKeys;